import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { PainPoints } from './components/PainPoints';
import { ProductBreakdown } from './components/ProductBreakdown';
import { Bonuses } from './components/Bonuses';
import { WhyChoose } from './components/WhyChoose';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { DetailedTestimonials } from './components/DetailedTestimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  useEffect(() => {
    // Preconnect to the image CDN to shave off DNS/TLS time for the LCP asset.
    const preconnect = document.createElement('link');
    preconnect.rel = 'preconnect';
    preconnect.href = 'https://cdn.magicpatterns.com';
    preconnect.crossOrigin = 'anonymous';
    document.head.appendChild(preconnect);
    // Preload the ACTUAL hero image (LCP element) with high priority so it
    // starts downloading immediately instead of the previous unused asset.
    const imgLink = document.createElement('link');
    imgLink.rel = 'preload';
    imgLink.as = 'image';
    imgLink.href = 'https://cdn.magicpatterns.com/uploads/scxrHoEmFJXbkQ88ujUNfn/ChatGPT-Image-30-jun-2026_-04_23_24-p.m..webp';
    imgLink.setAttribute('fetchpriority', 'high');
    document.head.appendChild(imgLink);
    return () => {
      preconnect.remove();
      imgLink.remove();
    };
  }, []);
  return <main className="w-full min-h-screen bg-light selection:bg-electric selection:text-navy overflow-x-hidden" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <div className="bg-electric text-navy font-bold md:text-sm text-center py-2 px-4 uppercase tracking-wider text-[10px]" data-id="element-2">
        ACCESO INMEDIATO | 80% DE DESCUENTO SOLO POR HOY
      </div>
      <Hero data-id="element-3" />
      <SocialProof data-id="element-4" />
      <PainPoints data-id="element-5" />
      <ProductBreakdown data-id="element-6" />
      <Bonuses data-id="element-7" />
      <WhyChoose data-id="element-8" />
      <Countdown data-id="element-9" />
      <Pricing data-id="element-10" />
      <DetailedTestimonials data-id="element-11" />
      <FAQ data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />
    </main>;
}